import { ConnectedClassIndicator, theme } from '@geneo2-web/shared-ui';
import { useMediaQuery } from '@mui/material';

// Reuses the actual shared ConnectedClassIndicator (Clicker's live-session
// stat bar) instead of a lookalike — `isOnline` is hardcoded true (a
// web-only quiz has no base-station connection to gate on) and `label`
// overrides its hardcoded "Connected Class" text, per the props added to
// that component for exactly this reuse. The 'connected' variant renders
// nothing below the md breakpoint (Clicker's own desktop-only layout), so
// this switches to 'connectedmobile2' on mobile exactly like
// ConnectedClassIndicatorWithDetails does.
interface IProps {
  totalJoined: number;
  totalStudents: number;
  totalAnswered: number;
  correct?: number;
  // Both scoped to the last-ended question (there's no running-session-wide
  // average shown here, matching Clicker's own per-question "Average
  // Time"/"Average Score" boxes) — averageTime in seconds, averagemarks as
  // the % of answered students who got it correct.
  averageTime?: number;
  averagemarks?: number;
}
export const LiveQuizIndicatorBar = (props: IProps) => {
  const { totalJoined, totalStudents, totalAnswered, correct, averageTime, averagemarks } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ConnectedClassIndicator
      variant={isMobile ? 'connectedmobile2' : 'connected'}
      fullwidth
      isOnline
      label="Geneo Live Quiz"
      totalJoined={totalJoined}
      totalStudents={totalStudents}
      totalAnswered={totalAnswered}
      correct={correct}
      averageTime={averageTime}
      averagemarks={averagemarks}
    />
  );
};

export default LiveQuizIndicatorBar;
